import { forwardRef } from 'react'

const BASE =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-xl ' +
  'text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ' +
  'outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)] border'

const VARIANTS = {
  primary:  'border-transparent bg-[var(--coral)] text-white hover:opacity-90 active:opacity-80 shadow-sm',
  ghost:    'bg-[var(--surface)] border-[var(--border)] text-[var(--ink-2)] hover:bg-[var(--bg-soft)]',
  green:    'border-transparent bg-[var(--mint)] text-white hover:opacity-90 shadow-sm',
  gold:     'border-transparent bg-[var(--butter)] text-[var(--ink)] hover:opacity-90 shadow-sm',
  disabled: 'bg-[var(--bg-soft)] border-[var(--border)] text-[var(--ink-3)] cursor-not-allowed',
}

const Button = forwardRef(function Button(
  { variant = 'primary', block = false, className = '', children, disabled, ...props },
  ref,
) {
  const effective = disabled ? 'disabled' : variant
  return (
    <button
      ref={ref}
      disabled={disabled}
      className={`${BASE} ${VARIANTS[effective] ?? VARIANTS.primary} ${block ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
})

export default Button
